import canTmsLogo from "assets/tcbtms.png";
import { canTmsMeta } from "./meta/canTms";

export const APP_DOMAIN = {
  TMS: "canTms",
  //FSW: "firstsourceworld",
};

export const APP_DOMAIN_MAP = {
  [APP_DOMAIN.TMS]: {
    ...canTmsMeta,
    logo: canTmsLogo,
    logoSmall: canTmsLogo,
  },
  // [APP_DOMAIN.FSW]: {
  //   ...fswMeta,
  //   logo: FSW,
  //   logoSmall: FSWSmall,
  // },
};
